import { render, staticRenderFns } from "./participantsTotals.vue?vue&type=template&id=5d5b7c67&scoped=true"
import script from "./participantsTotals.vue?vue&type=script&lang=js"
export * from "./participantsTotals.vue?vue&type=script&lang=js"
import style0 from "./participantsTotals.vue?vue&type=style&index=0&id=5d5b7c67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5b7c67",
  null
  
)

export default component.exports